import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  width: "100%",
  border: "1px",
  style: {"table-layout":"fixed"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Tranche "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","width":"15%"} }, " Institute "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Course "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Batche No ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, null, -1)
const _hoisted_5 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_6 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_7 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_8 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_9 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("template", null, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.batchInfo, (batch, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _hoisted_4,
              _createElementVNode("td", _hoisted_5, _toDisplayString(batch?.tranche_info?.label), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(batch?.entity_info?.entity_name), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(batch?.institute_info?.institute_name), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(batch?.course_info?.course_name), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(batch?.batch_sequence_number), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}